import AiWriterApp from './ai-write';

export default AiWriterApp;
